import React from "react";
import {
	Box,
	Flex,
	Button,
	FormControl,
	FormLabel,
	Heading,
	Input,
	Link,
	Switch,
	Text,
	useColorModeValue,
	Checkbox,
} from "@chakra-ui/react";
import { Link as ReachLink } from "react-router-dom";

function ResetPass() {
	const titleColor = useColorModeValue("teal.300", "teal.200");
	const textColor = useColorModeValue("gray.400", "white");
	return (
		<Flex
			align="center"
			justify="center"
			h={{ sm: "initial", md: "90vh", lg: "90vh" }}
			pt={{ sm: "100px", md: "10px" }}
			mt={10}
		>
			<Box
				bg="#33333B"
				borderRadius="16px"
				p="20px"
				pt={0}
				style={{ userSelect: "none" }}
				w={{ base: "100%", md: "50%", lg: "500px" }}
			>
				<Flex
					direction="column"
					align="center"
					gap={5}
					w="100%"
					p="48px"
					pt={10}
					// mt={{ md: "150px", lg: "80px" }}
				>
					<Heading color="#ffff" fontSize="32px">
						Recover Your Password
					</Heading>

					<FormControl>
						<FormLabel fontSize="sm" fontWeight="normal">
							Email
						</FormLabel>
						<Input
							borderRadius="15px"
							fontSize="sm"
							mb={5}
							type="text"
							placeholder="Your email adress"
							size="lg"
						/>

						<Button
							fontSize="10px"
							type="submit"
							bg="#16BF5D"
							w="100%"
							h="45"
							color="white"
							_hover={{
								bg: "#0af26b",
							}}
							_active={{
								bg: "teal.400",
							}}
						>
							Recover Password
						</Button>
					</FormControl>

					<Text color="#83888D" fontWeight="medium">
						Go back to
						<Link
							color="#16BF5D"
							as={ReachLink}
							to="signin"
							ms="5px"
							fontWeight="bold"
						>
							Login
						</Link>
					</Text>
				</Flex>
			</Box>
		</Flex>
	);
}

export default ResetPass;
